import React from "react"

import MetaTag from "components/Common/Meta-tag"
import InspectionDocumentDetails from "./Details"

function VehicleDetail() {
  return (
    <>
      <MetaTag title={"About Inspection Document"} />
      <InspectionDocumentDetails />
   
    </>
  )
}

export default VehicleDetail
